import { useSelector } from 'react-redux';
import { isAuthenticated as isAuthenticatedSelector } from 'selectors/app';

export const useAuthenticationState = () => {
  const { isAuthenticated } = useSelector(isAuthenticatedSelector);
  return isAuthenticated;
};
